import classNames from 'classnames';
import { isBefore } from 'date-fns';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import { Rate, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { checkIfModerationComplete } from '../../../../helpers/reviews';
import { TReviewCardProps } from '../../index';
import styles from '../../review-card.module.scss';

interface IProps extends Pick<TReviewCardProps, 'review'> {}

export const RateStatus: React.FC<IProps> = ({ review }) => {
  const isMobile = useIsMobile();
  const isOld = isBefore(new Date(review.date), new Date(2013, 1, 1));

  if (isOld) return null;

  let rating = review.rating;
  let statusText;
  let statusTextColor = 'h-color-D30';

  const requireUserData = review.userDataStatus === 'requested';

  if (review.ratingStatus === 'rateChecking') {
    if (requireUserData) {
      statusText = 'Ждём дополнения от автора';
    } else if (!isEmpty(review.moderationReasons)) {
      statusText = 'На модерации';
      rating = null;
    } else {
      statusText = 'Проверяем оценку';
    }
  } else if (review.ratingStatus === 'rateRejected') {
    rating = null;
    statusText = 'Оценка отклонена';
  } else if (
    review.ratingStatus === 'rateNotAvailable' ||
    review.ratingStatus === 'unknown' ||
    review.rating === null
  ) {
    rating = null;
    statusText = 'Без оценки';
  }

  const transparentStatus = requireUserData && !checkIfModerationComplete(review);

  return (
    <Space
      size={isMobile ? 0 : 8}
      align={isMobile ? 'end' : 'center'}
      justify={'end'}
      direction={isMobile ? 'vertical' : 'horizontal'}
    >
      <Rate
        className={classNames(styles.rateStars, transparentStatus && styles['rateStars--checking'])}
        value={rating}
        disabled
      />
      {statusText && (
        <Typography.Text size={14} className={statusTextColor} nowrap>
          {statusText}
        </Typography.Text>
      )}
    </Space>
  );
};
